/*eslint-disable */
import React, { useState, useEffect } from "react";
import {
  Button,
  Modal,
  Form as FormUi,
  Icon,
  Dropdown,
} from "semantic-ui-react";
import { withFormik, Field as Fieldmik, FieldArray } from "formik";
import ReadAxios from "../../axiosComponent/read";
import { isEmpty } from "lodash";
import UpdateAxios from "../../axiosComponent/update";
import CreateAxios from "../../axiosComponent/create";
import { DateData } from "../../dynamicComponent/datepick";
import { connect } from "react-redux";
import {
  successAlertDispatcher,
  errorAlertDispatcher,
} from "../../../redux/actions/alertAction";
import moment from 'moment';
import { setHours, setMinutes } from 'date-fns';
import cogoToast from "cogo-toast";
import 'moment-timezone';
import { translate } from "react-i18next";

const ModalVehicle = ({ values, isSubmitting, handleSubmit, setFieldValue, t, props, delivery_status, movement_type }) => {
  const [deliverStatus, setdeliverStatus] = useState(0);
  const [VehicleStatus, setvehicleStatus] = useState([]);

  useEffect(() => {
    getStatus();
  }, []);

  const getStatus = () => {
    ReadAxios({ completeURL: `${process.env.REACT_APP_TA_API_URL}/deliveries/vehicle/reporting/status/${movement_type}` })
      .then((res) => {
        isEmpty(res.data)
          ? setvehicleStatus([])
          : setvehicleState(res.data);
      })
      .catch((err) => setvehicleStatus([]));
  };

  const setvehicleState = (dataArray) => {
    let result = dataArray.data.map((item, index) => {
      return {
        raw: { ...item },
        text: item.delivery_text,
        key: item.delivery_status_id,
        value: item.delivery_code,
      };
    });

    setvehicleStatus(result);
  };

  let handleSubmited = () => {
    if (values.event_timestamp)
      handleSubmit();
  };

  let d1 = values.event_timestamp ? values.event_timestamp : new Date()
  let d2 = new Date()
  let compareDate;
  let date = moment(d1, 'DD-MM-YYYY HH:mm').format('DD-MM-YYYY')
  let date2 = moment(d2).format('DD-MM-YYYY')
  compareDate = date == date2 ? true : false

  return (
    <div className="ui form form-inline">
      <FormUi.Group inline >
        <FormUi.Field >
          <DateData
            name="event_timestamp"
            autoComplete="off"
            showTimeSelect
            className="fontSmall"
            timeFormat="HH:mm"
            popperClassName="dateTime"
            dateFormat="dd/MM/yyyy HH:mm"
            // timeIntervals={5}
            maxDate={new Date()}
            minTime={setHours(setMinutes(new Date(), 0), 0)}
            maxTime={setHours(setMinutes(new Date(), compareDate ? new Date().getMinutes() : 59), compareDate ? new Date().getHours() : 23)}
            selected={d1}
            customInput={
              <FormUi.Input
                icon="time"
                className="dateWidth"
                iconPosition="left"
              />
            }
          />
        </FormUi.Field>
        <FormUi.Field >
          <Dropdown
            name="event_code"
            clearable
            style={{ width: "10%" }}
            className="fontSmall"
            search
            selection
            placeholder={"Select Status"}
            onChange={(name, data) => setFieldValue("event_code", data.value)}
            options={VehicleStatus}
            defaultValue={values.event_code}
          />
          {console.log(values)}
        </FormUi.Field>
        <FormUi.Field >
          <Button
            type="submit"
            onClick={handleSubmited}
            // disabled={isSubmitting ? false : true}
            size="mini"
            basic color="green"
          >
            Save
          </Button>
        </FormUi.Field>
      </FormUi.Group>
    </div>
  );
};
const FormikStatusChange = withFormik(
  {
    mapPropsToValues(props) {
      let newDateValue = moment(props.delivery_time, 'DD-MM-YYYY HH:mm').format('YYYY-MM-DD HH:mm')
      return {
        event_timestamp: props.delivery_time != "NA" ? new Date(newDateValue) : new Date(),
        event_code: props.delivery_status != 'NA' ? props.delivery_status : ""
      };
    },
    handleSubmit(values, { setSubmitting, props }) {
      let URL = ""
      values.event_timestamp = moment(values.event_timestamp).format('YYYY-MM-DD HH:mm')
      URL = `${process.env.REACT_APP_TA_API_URL}/deliveries/${props.delivery_id}/vehicle/reporting/status`
      if (moment.parseZone(values.event_timestamp).format('YYYY-MM-DD HH:mm') > moment.parseZone(new Date()).format('YYYY-MM-DD HH:mm')) {
        cogoToast.error("Selected time is invalid")
        setSubmitting(false)
      }
      else {
        UpdateAxios({
          patchURL: URL, payload: values,
        })
          .then((res) => {
            setSubmitting(false);
            props.successAlertDispatcher({
              type: "success",
              messageHeader: "Success",
              messageBody: res.data.message,
            });
            window.location.reload();
          })
          .catch((err) => {
            console.log('err.response',err.response);
            props.successAlertDispatcher({
              type: "error",
              messageHeader: "Error",
              messageBody: err.response.data.message,
            });
          });
      }
    },

  })(ModalVehicle);

export default connect(null, { successAlertDispatcher, errorAlertDispatcher })(
  translate("allot")(FormikStatusChange)
);
